import { useMemo } from 'react';

import { Button } from '@/components/ui/button.tsx';
import { useSessionStore } from '@/hooks/use-session-store/use-session-store';
import { prettyTypeName } from '@/types/insurance.type.ts';

interface Props {
  onAccept: () => void;
}

export function DiscoveryCommercialNote({ onAccept }: Props) {
  const { insuranceBuilder } = useSessionStore();

  const carrierNames = useMemo(
    () => [...insuranceBuilder.carrierTypes].map(prettyTypeName),
    [insuranceBuilder.carrierTypes]
  );

  return (
    <div
      className="space-y-6 text-center"
      role="status"
      aria-live="polite"
      aria-labelledby="eligibility-result"
    >
      <div>
        <h2 id="eligibility-result" className="mb-4 font-serif text-2xl">
          Note:
        </h2>
        <p className="mb-6 font-serif text-xl">
          We'll determine your eligibility based on your {carrierNames.join(' & ')} benefits.
        </p>
        <p className="text-base text-gray-700">
          We're currently servicing Medicaid & Medicare plans only.
        </p>
      </div>

      <Button onClick={onAccept} className="w-full">
        I understand
      </Button>
    </div>
  );
}
